// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__Il_tu","blueHover":"Card_blueHover__B44_N","inner":"Card_inner__9naT5"};